import {InputFormatType as ift} from "../../../../formability/form_builder/models/inputFormatType";
import {ObjectModelPropertyRootType as omt} from "~/enums/objectModelPropertyType";
import {SalesforceApiDataType as sft} from "~/enums/salesforceApiDataType";
import {PickListSelectionType} from "~/enums/pickListSelectionType";
import {DatetimeMode} from "~/models/datetimeMode";

// will generate a warning

export const baseModelPropertyIncompatibleTypes = {
  [omt.LongText]: {
    Salesforce: [
      sft.address,
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.time,
      sft.int
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Alphanumeric,
          ift.None,
          ift.Zip
        ]
      },
      omt.PickList,
      omt.Number,
      omt.DateTime
    ]
  },
  [omt.DateTime]: {
    Salesforce: [
      sft.address,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Zip
        ]
      },
      omt.PickList,
      omt.Number
    ]
  },
}

const baseDateTimeIncompatibleTypes = {
  ObjectModelProperties: [
    {
      [omt.Text]: [
        ift.Phone,
        ift.Email,
        ift.Url,
        ift.Pattern,
        ift.SocialSecurity,
        ift.Zip
      ]
    },
    omt.PickList,
    omt.Number
  ],
  Salesforce: [
    sft.string,
    sft.base64,
    sft.boolean,
    sft.byte,
    sft.double,
    sft.address,
    sft.comboBox,
    sft.currency,
    sft.dataCategoryGroupReference,
    sft.email,
    sft.id,
    sft.junctionIdList,
    sft.location,
    sft.masterrecord,
    sft.multipicklist,
    sft.picklist,
    sft.reference,
    sft.url,
    sft.phone,
    sft.int,
  ]
}

export const dateTimeModelPropertyIncompatibleTypes = {
  [DatetimeMode.Datetime]: Object.assign({
    Salesforce: [
      sft.date,
      sft.time,
    ],
  }, baseDateTimeIncompatibleTypes),
  [DatetimeMode.Date]: Object.assign({
    Salesforce: [
      sft.datetime,
      sft.time,
    ]
  }, baseDateTimeIncompatibleTypes),
  [DatetimeMode.Time]: Object.assign({
    Salesforce: [
      sft.date,
      sft.datetime,
    ]
  }, baseDateTimeIncompatibleTypes),
}


export const pickListModelPropertyIncompatibleTypes = {
  [PickListSelectionType.SingleSelect]: {
    Salesforce: [
      sft.address,
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.reference,
      sft.url,
      sft.phone,
      sft.textarea,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.string,
      sft.time,
      sft.int
    ],
    ObjectModelProperties: [
      omt.Text,
      omt.LongText,
      omt.Number,
      omt.DateTime
    ]
  },
  [PickListSelectionType.MultiSelect]: {
    Salesforce: [
      sft.address,
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.percent,
      sft.reference,
      sft.url,
      sft.phone,
      sft.textarea,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.string,
      sft.time,
      sft.int
    ],
    ObjectModelProperties: [
      {
        [omt.PickList]: [
          PickListSelectionType.SingleSelect
        ]
      },
      omt.Text,
      omt.LongText,
      omt.Number,
      omt.DateTime
    ]
  }
}

export const numberModelPropertyIncompatibleTypes = {
  [ift.Numeric]: {
    Salesforce: [
      sft.address,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.junctionIdList,
      sft.multipicklist,
      sft.picklist,
      sft.url,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.int,
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Zip
        ]
      },
      omt.PickList,
      omt.DateTime
    ]
  },
  [ift.Currency]: {
    Salesforce: [
      sft.address,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.id,
      sft.location,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.url,
      sft.phone,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.string,
      sft.time
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Zip
        ]
      },
      omt.PickList,
      omt.DateTime
    ]
  }

}


export const shortTextModelPropertyIncompatibleTypes = {
  [ift.Phone]: {
    Salesforce: [
      sft.address,
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.reference,
      sft.url,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.time,
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Zip
        ],
      },
      {
        [omt.Number]: [
          ift.Currency
        ]
      },
      omt.PickList,
      omt.DateTime,
    ]
  },
  [ift.Email]: {
    Salesforce: [
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.time,
      sft.int
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Alphanumeric,
          ift.Zip
        ],
      },
      omt.Number,
      omt.PickList,
      omt.DateTime,
    ]
  },
  [ift.Url]: {
    Salesforce: [
      sft.address,
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.phone,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.string,
      sft.time,
      sft.int
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Zip
        ],
      },
      omt.Number,
      omt.PickList,
      omt.DateTime,
    ]
  },
  [ift.Pattern]: {
    Salesforce: [
      sft.address,
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.string,
      sft.time,
      sft.int
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Url,
          ift.SocialSecurity,
          ift.Alphanumeric,
          ift.None,
          ift.Zip
        ],
      },
      omt.Number,
      omt.PickList,
      omt.DateTime,
    ]
  },
  [ift.SocialSecurity]: {
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.string,
      sft.time,
      sft.int,
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.None,
          ift.Zip
        ],
      },
      omt.Number,
      omt.PickList,
      omt.DateTime,
    ]
  },
  [ift.Alphanumeric]: {
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.textarea,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.string,
      sft.time,
      sft.int,
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Zip
        ],
      },
      omt.Number,
      omt.PickList,
      omt.DateTime,
    ]
  },
  [ift.Zip]: {
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.string,
      sft.time,
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
        ],
      },
      omt.Number,
      omt.PickList,
      omt.DateTime,
    ]
  },
  [ift.None]: {
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.textarea,
      sft.base64,
      sft.boolean,
      sft.byte,
      sft.date,
      sft.datetime,
      sft.double,
      sft.time,
      sft.int
    ],
    ObjectModelProperties: [
      {
        [omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Zip
        ],
      },
      omt.Number,
      omt.PickList,
      omt.DateTime,
    ]
  }
}